<template>
  <el-container>
    <main class="tab__container">
      <h2 class="page__title">Домофон: {{ intercom.short_name }}</h2>
      <el-tabs ref="tabs">
        <el-tab-pane v-for="(tab, i) in components" :label="tab.name" :key="i">
          <component
            v-loading="loading && tab.name === 'Информация'"
            v-bind="tab.props"
            :is="tab.component"
            :intercom-id="id"
          />
        </el-tab-pane>
      </el-tabs>
    </main>
  </el-container>
</template>

<script>
import { checkPermission } from "@/core/helpers/permissions";
import { mapActions, mapState } from "vuex";
import IntercomEditTab from "@/components/Intercom/components/tabs/IntercomEditTab";

export default {
  name: "Intercom",
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    const tabs = [
      {
        name: "Информация",
        component: IntercomEditTab,
        permission: "intercoms:read",
      },
    ];
    return {
      loading: false,
      components: tabs.filter(({ permission }) => checkPermission(permission)),
    };
  },
  computed: {
    ...mapState("intercom", ["intercom"]),
  },
  watch: {
    id: {
      immediate: true,
      handler(id, prevId) {
        this.loadIntercom();
        if (prevId) this.$refs.tabs.setCurrentName("0");
      },
    },
  },
  methods: {
    ...mapActions("intercom", {
      getIntercom: "GET_INTERCOM",
    }),
    loadIntercom() {
      this.loading = true;
      this.getIntercom(this.id).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
